import {EventNumberPage, MetaData} from '@/components'
import { initializeStore } from '@/store'
import { getAreaInfoById, fetchAreaInfo } from '@/store/slices/stagesSlice/stagesSlice'
import { NextPage } from 'next'

const NextEventNumberPage: NextPage<{ areaId: string; eventId: string }> = ({
  areaId,
  eventId,
}) => {
  return (
    <>
      <MetaData />
      <EventNumberPage areaId={areaId} eventId={eventId} />
    </>
  )
}

NextEventNumberPage.getInitialProps = async ({ query }) => {
  const areaId: string = query.areaId as string
  const eventId: string = query.eventId as string
  const reduxStore = initializeStore()
  const { dispatch, getState } = reduxStore

  const response = getAreaInfoById(getState(), areaId)
  if (!response.data) {
    await dispatch(fetchAreaInfo({ id: areaId }))
  }

  return {
    initialReduxState: reduxStore.getState(),
    areaId,
    eventId,
    headerLayout: 'back',
  }
}

export default NextEventNumberPage
